import React from "react";
import "./MainContent.scss";
export default function MainContent({ children }) {
  return (
    <section
      className={`grid grid-cols-1 min-h-screen portal-shell main-content-dashboard`}
    >
      {children}
    </section>
  );
}
